export default __webpack_public_path__ + "static/media/Newsletter 029.3b9eecbc.png";